import React, { useContext, useEffect, useState } from 'react'
import useToastContext from '../hooks/useToastContext'
import 'chartjs-adapter-date-fns'
import {
  FcPortraitMode,
  FcNightPortrait,
  FcDownload,
  FcHome,
  FcAreaChart
} from 'react-icons/fc'
import { apiGet } from 'utils/apiFetch'
import pathObj from 'utils/apiPath'
import transactionSvg from 'assets/icons/transaction.svg'
import walletSvg from 'assets/icons/wallet.svg'
import CountUp from 'react-countup'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Chart } from 'react-google-charts'
import { useNavigate } from 'react-router-dom'
import UserIcon from '../assets/images/Users.svg'
import VerifiedUserIcon from '../assets/images/Verified Users.svg'
import UnverifiedUserIcon from '../assets/images/Unverified_users.svg'
import CategoryIcon from '../assets/images/categories.svg'
import SubCategoryIcon from '../assets/images/Sub_categries.svg'
import RequestIcon from '../assets/images/Totoal Request.svg'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js'
import AuthContext from 'context/AuthContext'
import DatePicker from 'react-date-picker'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { height } from '@mui/system'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
)

const monthsLabels = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
]

export const lineGraphOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'
    },
    title: {
      display: false,
      text: ''
    }
  },
  scales: {
    y: {
      beginAtZero: true
    }
  }
}

export const lineGraphData = {
  labels: [],
  datasets: [
    {
      label: 'Users',
      data: []
    }
  ]
}

export const lineGraphOptions2 = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'
    },
    title: {
      display: false,
      text: ''
    }
  },
  scales: {
    y: {
      beginAtZero: true
    }
  }
}

export const lineGraphData2 = {
  labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  datasets: [
    {
      label: 'Sales',
      data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  ]
}

export const options = {
  title: 'Total Verified and Unverified Users'
}

function Home() {
  const navigate = useNavigate()

  const { t } = useTranslation()
  let { user, logoutUser, updatePageName } = useContext(AuthContext)
  const [dateRange, setDateRange] = useState({
    start_date: '',
    end_date: ''
  })
  const [graphPayload, setGraphPayload] = useState({
    graphYear: '2023',
    graphMonth: '-1'
  })
  const [dashboardDetails, setDashboardDetails] = useState({})

  const [usersGraphYears, setUsersGraphYears] = useState([])
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [isReset, setIsReset] = useState(false)
  const handleDateChange = (start, end) => {
    setStartDate(start)
    setEndDate(end)
  }
  const data = [
    ['Task', 'Hours per Day'],
    ['Verified Users', dashboardDetails?.totalNoOfVerifiedUsers],
    ['Unverified Users', dashboardDetails?.totalNoOfNonVerifiedUsers]
  ]
  // useEffect(() => {
  //   if (graphPayload.graphMonth !== "-1") {
  //     if (dashboardDetails?.userGraph?.daysList) {
  //       const newDates = dashboardDetails?.userGraph?.daysList;
  //       lineGraphData.labels = newDates;
  //       // working on y axis data
  //       let refData = lineGraphData.datasets[0].data;
  //       while (refData.length > 0) {
  //         refData.pop();
  //       }
  //       const daysEarnReport = dashboardDetails?.userGraph?.daysEarnReport;
  //       for (let i = 0; i < daysEarnReport.length; i++) {
  //         refData.push(daysEarnReport[i]);
  //       }
  //       lineGraphData.datasets[0].data = refData;

  //       setReRender((prev) => !prev);
  //     }
  //   } else {
  //     if (dashboardDetails?.userGraph?.monthlyEarnReport) {
  //       // working on y axis data
  //       let refData = lineGraphData.datasets[0].data;
  //       while (refData.length > 0) {
  //         refData.pop();
  //       }
  //       const monthlyEarnReport =
  //         dashboardDetails?.userGraph?.monthlyEarnReport;
  //       for (let i = 0; i < monthlyEarnReport.length; i++) {
  //         refData.push(monthlyEarnReport[i]);
  //       }
  //       lineGraphData.labels = [...monthsLabels];
  //       setReRender((prev) => !prev);
  //     }
  //   }
  //   if (dashboardDetails?.userGraph?.graphDate) {
  //     let yearArray = [];
  //     yearArray.push(dashboardDetails?.userGraph?.graphDate?.endYear);
  //     for (
  //       let i = yearArray[0] - 1;
  //       i >= dashboardDetails?.userGraph?.graphDate?.startYear;
  //       i--
  //     ) {
  //       yearArray.push(i);
  //     }
  //     setUsersGraphYears([...yearArray]);
  //   }
  // }, [dashboardDetails]);

  const { start_date, end_date } = dateRange
  const onChange = event => {
    setDateRange({
      ...dateRange,
      [event.target.name]: event.target.value
    })
  }
  const [reRender, setReRender] = useState(false)

  const { graphMonth, graphYear } = graphPayload

  const getDashboardDetails = async () => {
    try {
      const payload = {
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        graphMonth,
        graphYear
      }
      const path = pathObj.getDashboardDetails
      const result = await apiGet(path, payload)
      setDashboardDetails({ ...dashboardDetails, ...result.data.results })
    } catch (error) {
      console.log('error:', error)
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    updatePageName(t('NAV_DASHBOARD'))
    getDashboardDetails()
  }, [startDate, endDate, graphPayload])

  const handleYearSelect = e => {
    setGraphPayload({
      ...graphPayload,
      graphYear: e.target.value
    })
  }
  const handleMonthSelect = e => {
    setGraphPayload({
      ...graphPayload,
      graphMonth: e.target.value
    })
  }
  const handleReset = () => {
    setEndDate('')
    setStartDate('')
    setIsReset(true)
  }
  return (
    <>
      <div className='sm:flex items-center text-center sm:text-left px-3 md:px-4 xl:px-7 lg:px-5  md:py-5 py-4 md:py-8 border'>
        <ODateRangePicker
          handleDateChange={handleDateChange}
          isReset={isReset}
          setIsReset={setIsReset}
        />
        <button
          type='button'
          onClick={handleReset}
          className='bg-LightBlue text-sm px-8 mb-3 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
        >
          {t('O_RESET')}
        </button>
      </div>
      {/* <input
            type="date"
            name="end_date"
            className="flex flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Select date"
            value={end_date}
            onChange={onChange}
          /> */}

      {/* <div className="flex items-center mb-3 sm:mb-0">
          <button
            type="button"
            className="flex ml-4 flex-row-reverse border border-[#E9EDF9] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Select date"
          >
            Reset
          </button>
        </div> */}

      <div className='py-4 px-4 md:px-8'>
        <div className='sale_report grid  3xl:grid-cols-4 gap-4 2xl:grid-cols-3 sm:grid-cols-2 mb-7 '>
          {/* {(user?.permission?.[1]?.view || user?.role === "admin") && (
            <div className="flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border">
              <h3 className="xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg">
                {dashboardDetails?.totalNoOfDownloads ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfDownloads}
                    />
                  </>
                ) : (
                  0
                )}
                <span className="lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block">
                  {t('O_DOWNLOADS')}
                </span>
              </h3>
              <span className="text-4xl ml-auto sm:mr-0  mt-2 sm:mt-0">
                <FcDownload />
              </span>
            </div>
          )} */}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfUsers ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfUsers}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfUsers ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfUsers}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_DOWNLOAD_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { occupations: 'farmer', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfFarmer ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfFarmer}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_FARMER_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { occupations: 'inputRetailer', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfRetailer ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfRetailer}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_RETAILER_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { occupations: 'livestockServiceProvider', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfLiveStock ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfLiveStock}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_LIVESTOCK_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { occupations: 'agriMachineryServiceProvider', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfAgriMachine ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfAgriMachine}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_AGRI_MACHINE_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { occupations: 'others', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfOthers ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfOthers}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_OTHER_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { verified: 'verified', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfVerifiedUsers ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfVerifiedUsers}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_VERIFIED_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={VerifiedUserIcon} alt='' />
              </span>
            </div>
          )}
          {(user?.permission?.[1]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { verified: 'notVerified', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfNonVerifiedUsers ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfNonVerifiedUsers}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_UNVERIFIED_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <img src={UnverifiedUserIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[4]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/users', { state: { verified: 'pending', startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalRequests ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalRequests}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_TOTAL_REQUESTS')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <img src={RequestIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[3]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/categories', { state: { startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalCategories ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalCategories}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_CATEGORIES')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <img src={CategoryIcon} alt='' />
              </span>
            </div>
          )}

          {(user?.permission?.[2]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/categories', { state: { startDate, endDate } })}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalSubCategories ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalSubCategories}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_SUB_CATEGORIES')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <img src={SubCategoryIcon} alt='' />
              </span>
            </div>
          )}

          {/* {(user?.permission?.[2]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalNoOfUsersPerOccupation ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfUsersPerOccupation}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_USERS_PER_OCCUPATION')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcAreaChart className='h-8 w-8' />
              </span>
            </div>
          )} */}
          {/* {(user?.permission?.[2]?.view || user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalAppointments ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalAppointments}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_APPOINTMENTS')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcAreaChart className='h-8 w-8' />
              </span>
            </div>
          )} */}
        </div>
      </div>
      <div style={{ width: '500px' }}>
        <Chart
          chartType='PieChart'
          data={data}
          options={options}
          width={'120%'}
          height={'400px'}
        />
      </div>
    </>
  )
}

export default Home
